import { defineMessages } from 'react-intl';

export default defineMessages({
    emailSent: {
        id: 'policy.common.directives.templates.email-proof-of-insurance-modal.A PDF Document has been sent to the email address on record',
        defaultMessage: "A PDF Document has been sent to the email address on record. If you don't receive your document, please check your junk folder to ensure it wasn't flagged as spam.",
    }
});
